"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemAPI = void 0;
const BaseAPI_1 = require("./BaseAPI");
class ItemAPI extends BaseAPI_1.BaseAPI {
    constructor() {
        super(...arguments);
        this.path = 'item';
    }
    all(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint(), filter);
        });
    }
    find(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint(id));
        });
    }
    store(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("name", data.name);
            formData.append("collectionId", data.collectionId);
            formData.append("supply", data.supply.toString());
            formData.append("image", data.image);
            if (data.traits)
                formData.append("traits", JSON.stringify(data.traits));
            if (data.description)
                formData.append("description", data.description);
            return yield this.requester.post(this.getEndpoint(), formData);
        });
    }
    update(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("name", data.name);
            if (data.image)
                formData.append("image", data.image);
            if (data.traits)
                formData.append("traits", JSON.stringify(data.traits));
            if (data.description)
                formData.append("description", data.description);
            return yield this.requester.put(this.getEndpoint(id), formData);
        });
    }
    bulk(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("collectionId", data.collectionId);
            for (const file of data.files)
                formData.append("files", file);
            return yield this.requester.post(this.getEndpoint("bulk"), formData);
        });
    }
    storeFromCID(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.post(this.getEndpoint("cid"), data);
        });
    }
    itemTraits(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint(id, "traits"));
        });
    }
    list(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.post(this.getEndpoint('list'), data);
        });
    }
    cancelList(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.post(this.getEndpoint(id, 'list', 'cancel'));
        });
    }
    listDetail(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint(id, 'list'));
        });
    }
    allList(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint('list'), filter);
        });
    }
    allNft(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint('nft'), filter);
        });
    }
    itemSupply(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint(id, "supply"));
        });
    }
    nft(collectionQuery, tokenId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint('nft', collectionQuery, tokenId));
        });
    }
    nftTraits(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.get(this.getEndpoint('nft', id, 'traits'));
        });
    }
    destroy(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requester.delete(this.getEndpoint(id));
        });
    }
}
exports.ItemAPI = ItemAPI;
